/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConditionKind } from './conditionKind';
import { ValueType } from './valueType';
import { AffinityGroup } from './affinityGroup';

/**
 * Price affecting condition, e.g. an incentive code.   (bipro-produktmodell::Kondition)
 */
export interface Condition {
  /**
   * Verti specific incentive code. Comes usually from a marketing campaign.
   */
  incentiveCode?: string;
  affinityGroup?: AffinityGroup;
  conditionKind?: ConditionKind;
  valueType?: ValueType;
  /**
   * Amount according to condition kind and value type.
   */
  value?: number;
}
export namespace Condition {}
